var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images && _vm.images.length)?_c('div',{staticClass:"bi-images"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('img',{attrs:{"src":item}})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }